<template>

  <v-container fluid class="mx-0 px-0" >
    <v-card class="mx-0 px-0">
      <v-overlay
        :absolute="true"
        :value="loadingFile"
      >
          <v-progress-circular
          :size="50"
          color="success"
          indeterminate
        >
        </v-progress-circular>
      </v-overlay>

      <v-card min-heigth="100" v-show="!mostrarArquivosCliente">
        <v-toolbar dense color="success" class="mx-0 px-0"> 
          <v-btn fab dark color="success darken-2" class="font-weight-light" @click="getFilesCliente" x-small>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <span class="px-2 subtitle-1 font-weight-black d-none d-sm-flex" style="color: white">Arquivos do Cliente</span>
          <span class="px-2 subtitle-1 font-weight-black d-flex d-sm-none" style="color: white">Arq. Cliente</span>
        </v-toolbar>
        <v-card-text>
          <span class="subtitle-1 font-weight-black"> Nenhum arquivo para incluir no processo... </span>
        </v-card-text>
      </v-card>

      <v-card v-show="mostrarArquivosCliente">
        <v-toolbar dense color="success">
          <v-btn fab dark color="success darken-2" class="font-weight-light" @click="getFilesCliente" x-small>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <span class="px-2 subtitle-1 font-weight-black d-none d-sm-flex" style="color: white">Arquivos do Cliente</span>
          <span class="px-2 subtitle-1 font-weight-black d-flex d-sm-none" style="color: white">Arq. Cliente</span>
        </v-toolbar>
        <v-container fluid class="my-0 py-0" v-show="images && images.length">
          <v-row class="my-0 py-0">
            <v-col
              v-for="(item, key) in images"
              :key="item.id ? item.id > 0 ? item.id : key : key"
              class="d-flex child-flex"
              cols="6" md="2"
            > <!--    -->
              <v-hover template v-slot:default="{ hover }">
                <v-card elevation="5" :loading="item.loading" :outlined="false">
                  <v-overlay
                    :absolute="true"
                    :value="item.loading"
                  >
                      <v-progress-circular
                      :size="50"
                      color="success"
                      indeterminate
                    >
                    </v-progress-circular>
                  </v-overlay>
                  <v-card-text class="py-1 my-1"><span class="font-weight-medium">{{ item.nome }}</span></v-card-text>
                  <v-img
                    :src="item.preview"
                    :src-lazy="item.preview"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  > 

                    <div class="text-center" v-show="item.downloadFile" style="background-color: silver; height: 100%;">
                      <v-progress-circular
                        :rotate="-90"
                        :size="70"
                        :width="8"
                        :value="item.progressFile"
                        z-index="10"
                        color="success"
                        style="top: 25px;"
                      >
                        {{ item.progressFile }}
                      </v-progress-circular>
                    </div>
                    <v-fade-transition>
                      <v-overlay
                        v-if="hover && item.id && !item.isErro && !item.downloadFile"
                        absolute
                        color="#036358"
                        z-index="3"
                      >
                        <v-row>
                          <v-btn min-width="85" z-index="3" @click="vizualizarItem(item)">Ver</v-btn>
                        </v-row>
                      </v-overlay>
                    </v-fade-transition>

                    <v-overlay
                      v-show="item.isErro"
                      absolute
                      value="true"
                      opacity="0.6"
                    >
                      <v-alert
                        color="red"
                        class="text-center my-0 py-0"
                        style="opacity: 0.6;"
                      >
                        <v-icon class="px-1 py-1 mx-o my-0">mdi-close-octagon</v-icon>              
                        <v-row
                          align="center"
                          no-gutters
                          class="px-0 py-0 mx-0 my-0"
                        >
                          <v-col class="grow">
                            Não Enviado
                          </v-col>
                        </v-row>
                      </v-alert>
                    </v-overlay>
                  </v-img>
                  <v-tooltip top dark color="grey darken-3">
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        class="px-0 py-0 mx-0 my-0"
                        x-small
                        absolute
                        dark
                        fab
                        bottom
                        right
                        z-index="5"
                        style="bottom: 10px; right: 5px"
                        @click="sendFile(item, key)"
                        :color="'blue'"
                        v-on="{...tooltip}"
                        v-show="!item.inInserido"
                      >
                        <v-icon class="px-0 py-0 mx-o my-0" small>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text text--darken-4 subtitle-2"> Inserir no Processo </span>
                  </v-tooltip>

                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

    </v-card>

  </v-container>

</template>

<script>

import apiClient from '@/plugins/axios'
import { mapMutations } from 'vuex'
import utilsLocal from "@/utils/filesDropBox";



export default {
  name: 'ArquivoClienteProcesso',
  props: ['cliente_id', 'processo_id', 'arq_processo'],
  data() {
    return {
      loadingFile: false,
      erros: '',
      images: [],
      gravados: [],
      mostrarArquivosCliente: true,
      downloadFile: false,
      progressFile: null,
      dialogIMG: false,
      imagemSel: null,
      dialogPDF: false,
      pdfSel: null,
      window: {
          width: 0,
          height: 0
      },
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.getFilesCliente()
  },
  watch: {
    images(newVal) {
      if (this.images && this.images.length) {
        this.mostrarArquivosCliente = true
      } else {
        this.mostrarArquivosCliente = false
      }
    },
    arq_processo(newVal, oldVal) {
      this.comparaArquivos()
    }
  },
  methods: {
    ...mapMutations({
      setFile: 'processo/SET_FILE',
    }),
    async getFilesCliente() {
      this.gravados = []
      this.images = []
      await this.$nextTick()
      await this.buscarArquivos()
      await this.ajustaArquivosPreview()
      await this.comparaArquivos()
      if (!this.images || !this.images.length) this.mostrarArquivosCliente = false
    },
    
    comparaArquivos() {
      this.images.forEach((fileC, key) => {
        var found = false
        if (this.arq_processo.length > 0) {
          this.arq_processo.forEach(fileP => {
            if (fileC.id == fileP.arquivopessoa_id) {
              found = true
              return false
            }
          })
        }
        this.images[key].inInserido = found
      })
    },

    async buscarArquivos() {
      this.loadingFile = true
      await apiClient.get(`filecliente/files/${this.cliente_id}`)
      .then(response => {
        if (response.data.status) {
          this.gravados = response.data.files
        } else if (!response.data.status && response.data.erro) {
            this.$toaster.error(response.data.erro)
            console.log('Erro ao buscar arquivos na api \n Erro:', response.data.erro)
        }
      })
      .catch(error => {
          console.log('Erro ao buscar arquivos na api');
      })
      .finally(() => this.loadingFile = false)
    },

    //ao carregar arquivos da api, ajusta para mostrar na DOM
    async ajustaArquivosPreview() {
      this.images = []
      if (this.gravados.length) {
        this.gravados.forEach( async (item) => {
          let img = await this.montaItemArquivoPreview(item)
          this.images.push(Object.assign({}, img))
        })
      }
      this.gravados = []
    },

    async montaItemArquivoPreview(item) {
      var file = { 
          id: item.id, 
          pessoa_id: this.pessoa_id, 
          nome: item.name, 
          type: item.type, 
          ext: item.extension, 
          file: item.file,
          preview: item.preview.preview,
          arquivopessoa_id: item.arquivopessoa_id,
          size: item.size ? item.size : 0,
          path_lower: item.path_lower,
          path_display: item.path_display,
          loading: false,
          downloadFile: false,
          progressFile: null,
          isMultiSelecionado: false,
          isEnviar: false,
          isErro: false,
          tipo: 'file',
          isUploading: false,
          inInserido: false,
      }
      return file
    },

    async sendFile(item, index) {
      item.loading=true

      apiClient.post(`fileprocesso/upload/file/cliente`, {
        file: item, parent_id: this.processo_id
      })
      .then(response => {
        if (response.data.status) {
          let file = response.data.file
          this.$emit("incluirArqProcesso", file)
        }
      })
      .catch(error => {
          console.log('Erro ao buscar arquivos na api');
      })
      .finally(() => item.loading=false)
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    
    async vizualizarItem(item) {
      item.progressFile = 0
      item.downloadFile = true
      let payload = {file: item.path_lower}
      utilsLocal.geraUrlToDownloadFile(`filecliente/download`, payload)
      .then(async(response) => {
        if (response.data.status) {          
          item.url = response.data.url.link
          try {
            var resp = await utilsLocal.downloadDropBoxByUrl(item)
          } catch (error) {
            this.$toaster.error('Catch: Erro ao gerar vizualização do arquivo')
            console.log(error)
          }
          item.downloadFile = false
        } else {
            item.downloadFile = false
            this.$toaster.error('Servidor retornou status=false para download do arquivo')
        }
      })
      .catch((e) => {
        item.downloadFile = false
        console.log('Catch vizualizarItem', e)
        this.$toaster.error('Catch: Erro ao gerar vizualização do arquivo')
      })
    }
  }
  
}

</script>


// WEBPACK FOOTER //
// src/views/Processo/ArquivosCliente.vue